module.exports = __webpack_public_path__ + "files/cc45e2ece15e64ee365b5d81f2989fc8.svg";